import { mapActions } from 'vuex';
import { decode } from 'utils/general';
import { trackNotifyMeBtnClicked } from '../../assets/js/lib/tracking';

export default {
  props: [
    'ctaType',
    'isGWP',
    'GWPOutOfStock',
    'thresholdReached',
    'giftSelected',
    'showGWPBtn',
    'isBundle',
    'handle',
    'product',
    'variants',
    'isRecommended',
    'parentTitle',
    'shadeSelected',
    'currentShade',
    'addingToCart',
    'isInlineCard',
    'listType',
    'cardIndex',
    'isBBCard',
    'selectedShades',
    'isBundleBuilderItem',
  ],
  data() {
    return {
      disabled: false,
    };
  },
  computed: {
    addText() {
      return this.isGWP || this.isBBCard
        ? this.$t('products.product.add')
        : this.$t('products.card.add');
    },
    addedText() {
      return this.$t('products.product.added');
    },
    recomendationText() {
      return this.addingToCart
        ? this.$t('products.card.adding')
        : this.$t('products.card.add');
    },
    OOOText() {
      return this.$t('cart.gwp.out_of_stock');
    },
    oosText() {
      return this.$t('products.card.out_of_stock');
    },
    notifyText() {
      return this.$t('products.card.notify');
    },
    preorderText() {
      return this.$t('products.card.preorder');
    },
    viewDetailsText() {
      return this.$t('products.card.view_details');
    },
    quickShopText() {
      return this.isGWP || this.isRecommended
        ? 'Quick Shop'
        : this.$t('products.card.quick_shop');
    },
    selectText() {
      return this.$t('cart.gwp.select');
    },
    selectedText() {
      return this.$t('cart.gwp.selected');
    },
    selectShadeText() {
      return this.$t('quick_view.select_shade');
    },
    shopNowText() {
      if (this.isDonateProduct) {
        return this.$t('products.card.donate_now');
      }
      if (this.isBundleBuilderItem) {
        return this.$t('products.card.customize');
      }
      return this.$t('products.card.shop_now');
    },
    selectGiftText() {
      return this.$t('cart.gwp.select');
    },
    vtoText() {
      return this.$t('products.card.vto');
    },
  },
  methods: {
    ...mapActions('global', [
      'addRemoveProductToList',
      'openModal',
      'updateBackInStock',
      'activeCountryCode',
    ]),
    ...mapActions('quickView', [
      'setProduct',
      'updateModalTitle',
      'updateCtaText',
      'setGWPModal',
      'updateItemToUpdate',
      'updateAction',
    ]),
    ...mapActions('cart', [
      'openCart',
      'closeCart',
      'addBundleItemsToCart',
      'updateCartLine',
    ]),
    getAddToCartType() {
      let addToCartType = 'Home';
      if (this.isRecommended) {
        addToCartType = 'Best Sellers';
      } else if (this.inlineQuickViewOpen) {
        addToCartType = 'Quick Add';
      } else {
        if (window.location.pathname.indexOf('/collections') > -1) {
          addToCartType = 'Product List Page';
          if (window.location.pathname.indexOf('/products') > -1) {
            addToCartType = 'Product Detail Page';
          }
        } else if (window.location.pathname.indexOf('/cart') > -1) {
          addToCartType = 'Cart';
        } else if (window.location.pathname.indexOf('/products') > -1) {
          addToCartType = 'Product Detail Page';
        } else if (window.location.pathname.indexOf('/pages') > -1) {
          addToCartType = 'Landing Page';
        } else if (window.location.pathname.indexOf('/account') > -1) {
          addToCartType = 'Account Page';
        }
      }

      return addToCartType;
    },
    addItemToCart(item) {
      if (this.isGWP) {
        const otherData = {
          reviews_average:
            item.product.metafields?.yotpo?.reviews_average || '',
        };
        this.addRemoveProductToList({
          id: item.id,
          tags: item.product.tags,
          otherData,
        });
      } else {
        this.$emit('add-item', item);
      }
      window.narvarCartWidgetReload();
    },
    redirectToProductPage() {
      this.$emit('track-item', false);
      window.location = `${Shopify.routes.root}products/${this.handle}`;
    },
    redirectToProductPageWithVTO() {
      this.$emit('track-item', false);
      window.location = `${Shopify.routes.root}products/${this.handle}?try-shade=true`;
    },
    openInlineQuickView() {
      this.inlineQuickViewOpen = true;
    },
    closeInlineQuickView() {
      this.inlineQuickViewOpen = false;
    },
    openQuickShopModal() {
      if (this.isGWP) {
        this.setGWPModal(true);
      }

      let product = this.product;
      if (typeof this.product === 'string') {
        product = JSON.parse(decode(this.product));
      }

      product = {
        ...product,
        parentTitle: this.parentTitle,
        listType: this.listType,
        selectedShades: this.product.selectedShades || false,
        origin: 'quick shop'
      };
      this.updateCtaText(this.$t('quick_view.add_to_bag'));
      this.setProduct(product);
      this.openModal('quick-view');
      this.trackSelectItem(this.product, true);
    },
    openNotifyModal() {
      this.updateBackInStock({
        product: this.product,
        variant: this.variants[0],
      });
      this.openModal('back-in-stock');
      trackNotifyMeBtnClicked(this.product.title, this.parentTitle, this.listType.replace('-', ' '))
    },
    validateAddToCart(id, quantity, sku) {
      const otherData = {
        reviews_average: this.product.metafields?.yotpo?.reviews_average || '',
      };
      this.isGWP
        ? this.addRemoveProductToList({ id, otherData })
        : this.addItemToCart({ id, quantity, sku });
    },
    validateRedirect(id) {
      this.isGWP
        ? this.addRemoveProductToList({ id })
        : this.redirectToProductPage();
    },
    removeProduct() {
      this.disabled = true;
      this.timeout = setTimeout(() => {
        this.disabled = false;
      }, 1000);

      this.addRemoveProductToList({
        id: parseInt(this.variants[0].id),
      });
    },
    trackSelectItem() {
      this.$emit('track-item', true);
    },
    addProductToBundle() {
      console.log('Product added to the bundle');
    },
  },
  template: `
    <div
      class="product-card__cta-primary"
      :class="{'product-card__cta-primary--with-bundle': isBundle, 'disabled': disabled }"
    >
      <button
        class="product-card__cta--vto btn btn--primary p4"
        v-if="ctaType === 'vto'"
        v-text="vtoText"
        @click.prevent="redirectToProductPageWithVTO"
        :aria-label="vtoText">
        {{ vtoText }}
        <slot></slot>
      </button>
      <button
        class="product-card__cta product-card__cta--select-shade btn"
        v-else-if="ctaType === 'select-shade' && !shadeSelected"
        @click.stop="openInlineQuickView"
        :aria-label="selectShadeText">
        {{ selectShadeText }}
        <slot></slot>
      </button>
      <button
        :class="{ 'disabled': (isGWP && !thresholdReached) }"
        class="product-card__cta product-card__cta--quick-buy btn"
        v-if="ctaType === 'quick-shop' && !giftSelected && showGWPBtn && !isInlineCard && !isBBCard"
        @click.prevent="openQuickShopModal"
        :aria-label="quickShopText">
        {{ quickShopText }}
        <slot></slot>
      </button>
      <button
        class="product-card__cta product-card__cta--notify btn disabled"
        v-else-if="ctaType === 'out-of-stock'"
        :aria-label="oosText">
        {{ oosText }}
        <slot></slot>
      </button>
      <button
        class="product-card__cta product-card__cta--notify btn "
        v-else-if="ctaType === 'notify'"
        @click.prevent="openNotifyModal"
        :aria-label="notifyText">
        {{ notifyText }}
        <slot></slot>
      </button>
      <button
        :class="{'product-card__cta-primary--with-bundle': isBundle }"
        class="btn btn--primary w1"
        v-else-if="ctaType === 'add' && !isGWP && !isBBCard"
        @click.prevent="validateAddToCart(variants[0].id, 1, variants[0].sku)"
        :aria-label="addText"
         data-module-name="product card cta actions">
        {{ addText }}
        <slot></slot>
      </button>
      <button
        :class="{ 'disabled': addingToCart }"
        class="btn btn--primary w1"
        v-else-if="ctaType === 'add-reco' && !isGWP || isInlineCard"
        @click.prevent="shadeSelected ? addItemToCart(currentShade) : validateAddToCart(variants[0].id, 1, variants[0].sku)"
        :aria-label="addText"
        data-module-name="product card cta actions">
        {{ addText}}
        <slot></slot>
      </button>
      <button
        :class="{ 'disabled': (addingToCart || isGWP && !thresholdReached) }"
        class="btn btn--primary w1"
        v-else-if="ctaType === 'add-reco' && isGWP && !giftSelected"
        @click.prevent="shadeSelected ? addItemToCart(currentShade) : validateAddToCart(variants[0].id, 1, variants[0].sku)"
        :aria-label="selectText"
        data-module-name="product card cta actions">
        {{ selectText }}
        <slot></slot>
      </button>
      <button
        :class="{ 'disabled': addingToCart, 'disabled': (isGWP && !thresholdReached && !giftSelected) }"
        class="btn btn--primary w1"
        v-else-if="ctaType === 'add-reco' && !isGWP"
        @click.prevent="shadeSelected ? addItemToCart(currentShade) : validateAddToCart(variants[0].id, 1, variants[0].sku)"
        :aria-label="addText"
        data-module-name="product card cta actions">
        {{ addText }}
        <slot></slot>
      </button>
      <button
        class="product-card__cta product-card__cta--add btn"
        v-else-if="ctaType === 'select-shade' && shadeSelected"
        @click.prevent="addItemToCart(currentShade)"
        :aria-label="addText"
        data-module-name="product card cta actions">
        {{ addText }}
        <slot></slot>
      </button>
      <button
        class="product-card__cta product-card__cta--add btn"
        v-else-if="ctaType === 'preorder'"
        @click.prevent="validateAddToCart(variants[0].id, 1, variants[0].sku)"
        :aria-label="preorderText"
        data-module-name="product card cta actions">
        {{ preorderText }}
        <slot></slot>
      </button>
      <button
        class="product-card__cta product-card__cta--shop-now btn"
        :class="{ 'product-card__cta--shop-now-hidemo': ctaType === 'quick-shop' && !giftSelected && showGWPBtn, 'disabled': (isGWP && !thresholdReached) }"
        v-else-if="ctaType === 'shop-now'"
        @click.prevent="validateRedirect(variants[0].id)"
       :aria-label="shopNowText"
       data-module-name="product card cta actions">
        {{ shopNowText }}
        <slot></slot>
      </button>
      <button
        class="btn btn--primary w1" v-else-if="isGWP && giftSelected"
        @click="removeProduct()"
        :aria-label="selectedText"
        data-module-name="product card cta actions">
         {{selectedText}}
      </button>
    </div>
  `,
};
